<!--upload image-->
<fieldset class="border-navyBlue" style="height: 435px">
  <!--document type name-->
  <legend class="bg-navyBlue">
    {{ documentTypes[counter]?.key | enumToText : documentTypes }}
  </legend>
  <div
    class="uploadSection"
    *ngIf="modelItems[counter]?.status != DocumentStatus.Accepted"
  >
    <div class="image-upload">
      <file-uploader
        [label]="'common.uploadFile'"
        class="tw-w-[275px] md:tw-w-5/12"
        (valueChange)="getFile($event)"
        [acceptFile]="allowedFiles"
        [maxFileSize]="1"
        sizeType="mb"
        (onErrorFile)="showErrorDialog($event)"
      >
      </file-uploader>
    </div>
  </div>

  <!--image preview-->

  <div *ngIf="imgUrl || (pdfUrl == null && imgUrl == null)" class="">
    <app-show-images class="tw-mt-1" [src]="imgUrl"></app-show-images>
  </div>

  <div *ngIf="pdfUrl" class="">
    <app-pdf-reader class="tw-mt-1" [src]="pdfUrl"></app-pdf-reader>
  </div>

  <!--info div-->
  <div>
    <div class="tw-mt-5 row document-info tw-justify-center">
      <div class="tw-w-full">
        <form-field
          *ngIf="modelItems[counter]?.status != undefined"
          class="tw-w-full"
          label="common.status"
          [isReadOnly]="true"
          [value]="
            modelItems[counter]?.status | enumToText : DocumentStatusEnumValues
          "
        >
        </form-field>

        <form-field
          *ngIf="modelItems[counter]?.status == undefined"
          class="tw-w-full"
          label="common.status"
          [isReadOnly]="true"
          [value]="
            DocumentStatus.NotCheckedYet | enumToText : DocumentStatusEnumValues
          "
        >
        </form-field>
      </div>
    </div>

    <!-- formControlName="description" -->
    <form-textarea
      class="tw-w-full"
      label="common.description"
      [value]="
        modelItems[counter]?.description != undefined
          ? modelItems[counter]?.description
          : ''
      "
      [rows]="2"
      [isReadOnly]="true"
    >
    </form-textarea>
  </div>
</fieldset>
